import React from 'react';
import { Card, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { UserAvatar } from '@components/Feature/User/user-avatar';
import { useNavigate } from 'react-router-dom';
import { Form, Formik, FormikHelpers, useFormikContext } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { object, string } from 'yup';
import { useRouteParam } from '@hooks/params';

import { FormGroupControl } from '@components/Base';
import { ServerError } from '@components/Helper';

import { passwordVerify, PasswordVerifyPayload } from '../action';
import { selectAuthRouteReducer } from '../selector';

type FormValues = PasswordVerifyPayload;

const FormForm = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { serverErrors } = useSelector(selectAuthRouteReducer);
  const { isSubmitting } = useFormikContext<FormValues>();

  return (
    <Form>
      <FormGroupControl
        type="password"
        name="password"
        label={t('common:password')}
        groupProps={{ className: 'mb-3' }}
      />

      <div className="d-grid gap-2">
        <Button type="submit" disabled={isSubmitting} variant="primary">
          {t('common:signIn')}
        </Button>
        <Button variant="outline-secondary" onClick={() => navigate('-1')}>
          {t('common:enterWrongNumber')}
        </Button>
      </div>
      <ServerError errors={serverErrors} />
    </Form>
  );
}

const AuthPasswordPage = () => {
  const { t } = useTranslation();
  const mobileNumber = useRouteParam('mobileNumber')!;
  const dispatch = useDispatch();

  const initialValues: FormValues = {
    mobileNumber,
    password: '',
  };

  const validationSchema = object({
    password: string().required(t('required:validation')),
  });

  const handleSubmit = (values: FormValues, { setSubmitting }: FormikHelpers<FormValues>) => {
    const payload: PasswordVerifyPayload = values;
    dispatch(passwordVerify(payload));
    setSubmitting(false);
  };

  return (
    <Card>
      <Card.Header className="text-center">
        <UserAvatar />
      </Card.Header>
      <Card.Body>
        <Card.Title>{t('registration.password.title')}</Card.Title>
        <Card.Text>
          {t('registration.password.title')}
          &nbsp;
          <strong>{mobileNumber}</strong>
        </Card.Text>

        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          <FormForm />
        </Formik>
      </Card.Body>
    </Card>
  );
};

export { AuthPasswordPage };
